<template>
  <div class="mainCont">
    <!--多对多物联平台-->

    <div class="m2mIntro" v-title data-title="广东多对多物联集团股份有限公司">
      <div class="introBox container">
        <img
          style="width: 100%"
          src="https://img.duoduiduo.com/gg/16/10/e181cdd5751c40698b0dc620a4e52804.jpg"
          alt=""
        />
        <!-- <h3 class="title header_title" style="margin-top: 40px;">数智健共体的五大核心优势</h3> -->
        <!-- <div class="line"></div> -->
        <!-- <p class="introCont col-sm-11">
					广东多对多物联集团股份有限公司成立于2017年10月，总部位于佛山市顺德区，是一家健康共同体数智增值服务平台企业，被誉为医康养行业背后的数智管家。
				</p> -->
        <!-- <div class="baner_list">
				<span class="xxxxxx" :class="acvieba == index?'xxxxxx-active':''" v-for="(item,index) in jiankangdata" :key="index" @click="jiankangdatabtn(index)">{{item}}</span>
				</div> -->
        <!-- <img v-show="acvieba == 0" style="width:100%;" src="../../assets/images/home/szjimg_1.png" alt="">
				<img v-show="acvieba == 1" style="width:100%;" src="../../assets/images/home/szjimg_2.png" alt="">
				<img v-show="acvieba == 2" style="width:100%;" src="../../assets/images/home/szjimg_3.png" alt="">
				<img v-show="acvieba == 3" style="width:100%;" src="../../assets/images/home/szjimg_4.png" alt="">
				<img v-show="acvieba == 4" style="width:100%;" src="../../assets/images/home/szjimg_5.png" alt=""> -->

        <img
          style="width: 100%"
          src="https://img.duoduiduo.com/gg/3/28/fdbe0f4fb47c47cfad6f36c9f93e3c44.jpg"
          alt=""
        />

        <div class="expertList">
          <!-- <img style="width:100%;" src="../../assets/images/home/22.png" alt=""> -->
          <!-- <ul class="row">
						<li class="zhzj">
							<div class="imgBox"><img
									src="https://img.duoduiduo.com/goods/8/35/16baaf60777b4b998f94e6a9e9991579.jpg"
									alt=""></div>
							<h3 class="title">开放社区</h3>
							<h3 class="title">物联应用系统</h3>
						</li>
						<li class="cjzj">
							<div class="imgBox"><img
									src="https://img.duoduiduo.com/goods/4/8/aa77a76cf17d400098ff88b31d999f7d.jpg"
									alt=""></div>
							<h3 class="title">开放系统</h3>
							<h3 class="title">设备无界物联</h3>
						</li>
						<li class="xtzj">
							<div class="imgBox"><img
									src="https://img.duoduiduo.com/goods/32/0/0154da29e9be4adb9140259d8d4f4585.jpg"
									alt=""></div>
							<h3 class="title">开放合作</h3>
							<h3 class="title">跨界增值服务</h3>
						</li>
					</ul> -->
        </div>
      </div>
    </div>
    <!--新闻资讯-->
    <!-- <div class="m2mIntro news">
			<div class="introBox container">
				<h3 class="title header_title">新闻资讯</h3>
				<div class="line"></div>
				<div class="newsBox row">
					<div class="left col-md-10 col-lg-7">
						<video id="video" controls="true" src="https://img.duoduiduo.com/videos/www/service_state20221029.mp4"
							x5-video-orientation="portraint" poster="~img/about/iframe22.png"></video>
						<div class="more" @click="toVideo">查看更多></div>
					</div>
					<div class="right col-md-10 col-lg-5">
						<div class="newsList">
							<div class="item row" v-for="(item,index) in newsList" :key="index"
								@click="toNewsCont(item.id)">
								<div class="newsImg col-4"><img :src="item.thumb" alt="多对多物联平台"></div>
								<div class="newsCont col-8">
									<div class="newstit">{{ item.title }}</div>
									<div class="newsTime">{{ item.create_time }}</div>
									                 <div class="line"></div>
									                 <div class="text">{{ item.description }}</div>
								</div>
							</div>
						</div>
						<div class="moreNews" @click="toNews" v-if="newsList.length>0">
							<div class="line"></div>
							<div class="text">查看所有新闻</div>
						</div>
					</div>
				</div>
			</div>

			<div class="honour">
				<h3 class="tit">实力见证</h3>
				<div class="line"></div>
				<div class="honourBox container">
					<div id="honour" class="carousel slide" data-ride="carousel">

						<ul class="honour_flex">
							<li>
								<img src="https://img.duoduiduo.com/goods/19/7/27a3bbe09cc44c359ae3a5cbf70c0375.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/31/29/5d9a2026dfec49a08b118cdfedc2402a.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/4/0/161d0f9da856472bbdff9d8e030c576e.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/17/11/c3cc3e29aaaf4bdc9f0b71d432527119.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/32/4/54923984c9634d10914d6229c9ee402d.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/1/6/a2d09f0b59d74fc78344f81db686d0af.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/3/6/530c5c93cdd643a7a0fb9e8624e1c3af.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/29/6/7177c7c7126f478e90d9fdb0fa8d53ea.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/18/16/389a11c3cf2e4e0c9f1ec939c2bd2de9.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/20/29/5cabb5baab2045118b7cca62c2bbe19c.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/24/32/cadd5a613a02489ca0fb42fa33b5b113.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/9/17/88c2bdb8ec1c4785933c4c5a2b3ef0f7.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/18/27/64f68841071c41499a9c925cf8d5ec25.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/25/30/26ddd3a413ca4cbeb2cab0e3c6a0c556.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/8/6/5fb850a7aa994a8599a2b39a5c28113c.jpg"
									alt="">
							</li>
							<li>
								<img src="https://img.duoduiduo.com/goods/31/3/e2cadf6b6e4449ca8bbd4fb38b9e8717.jpg"
									alt="">
							</li>
							<li><img src="https://img.duoduiduo.com/goods/28/7/2aa7421223894a4fae0a9ff004edbcce.png"
									alt=""></li>
						</ul>
					</div>
				</div>
			</div>

		</div> -->

    <!-- 企业荣誉 -->
    <!-- <div class="enterprise_honor">
			<div class="head_title">
				<h3 class="title">企业荣誉</h3>
				<p class="line"></p>
			</div>
			<div class="beckg_1"></div>
			<div class="beckg_2"></div>
			<div class="enterprise_honor_content">
				<div class="left"></div>
				<div class="content">
					<p>国家高新技术企业，广东高新技术产品，广东知识产权保护单位，中国节能低碳标兵，佛山知识产权新
						秀单位，中国家用电器商业协会副理事长单位，中国家电商业协会营销委员会会长单位，中国家电商业协会
						共享家电委员会会长单位，广东互联网+物联网产业联盟副理事长单位，广东商业联合会常务理事单位，广东
						商业联合会智慧生活研究院院长单位，江苏省家电商业协会副会长单位，山东只能家居协会副会长单位，ALLGO联盟
						联席主席单位，容桂总商会副会长单位...</p>
				</div>
				<div class="right"></div>
			</div>
		</div> -->

    <div class="m2mIntro cobrand" style="padding-bottom: 100px">
      <div class="introBox container">
        <!-- <h3 class="title header_title">多对多的每一步</h3> -->
        <!-- <div class="line"></div> -->
        <h3 class="title header_title" style="margin-top: 40px; color: #ee7b1d">
          数智健共体的五大核心优势
        </h3>
        <div class="line"></div>

        <div class="baner_list">
          <span
            class="xxxxxx"
            :class="acvieba == index ? 'xxxxxx-active' : ''"
            v-for="(item, index) in jiankangdata"
            :key="index"
            @click="jiankangdatabtn(index)"
            >{{ item }}</span
          >
        </div>
        <img
          v-show="acvieba == 0"
          style="width: 100%"
          src="../../assets/images/home/home_lun1.jpg"
          alt=""
        />
        <img
          v-show="acvieba == 1"
          style="width: 100%"
          src="../../assets/images/home/home_lun2.jpg"
          alt=""
        />
        <img
          v-show="acvieba == 2"
          style="width: 100%"
          src="../../assets/images/home/home_lun3.jpg"
          alt=""
        />
        <img
          v-show="acvieba == 3"
          style="width: 100%"
          src="../../assets/images/home/home_lun4.jpg"
          alt=""
        />
        <img
          v-show="acvieba == 4"
          style="width: 100%"
          src="../../assets/images/home/home_lun5.jpg"
          alt=""
        />

        <!-- <img style="width:100%;" src="../../assets/images/home/home_lun1.jpg" alt=""> -->

        <!-- <div  class="wrapperxxx"> -->
        <!-- <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
			        	<swiper-slide v-for="(item,index) in swiperData" :key="index">
			        		<img style="width: 100%;display: block;" :src="item.imgUrl">
			        	</swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
			        </swiper> -->

        <!-- </div> -->
      </div>
    </div>

    <!-- <h3 class="title header_title" style="margin-top: 40px;">数智健共体的五大核心优势</h3> -->
    <!-- <div class="line"></div> -->
    <!-- <p class="introCont col-sm-11">
					广东多对多物联集团股份有限公司成立于2017年10月，总部位于佛山市顺德区，是一家健康共同体数智增值服务平台企业，被誉为医康养行业背后的数智管家。
				</p> -->
    <!-- <div class="baner_list">
				<span class="xxxxxx" :class="acvieba == index?'xxxxxx-active':''" v-for="(item,index) in jiankangdata" :key="index" @click="jiankangdatabtn(index)">{{item}}</span>
				</div> -->
    <!-- <img v-show="acvieba == 0" style="width:100%;" src="../../assets/images/home/szjimg_1.png" alt="">
				<img v-show="acvieba == 1" style="width:100%;" src="../../assets/images/home/szjimg_2.png" alt="">
				<img v-show="acvieba == 2" style="width:100%;" src="../../assets/images/home/szjimg_3.png" alt="">
				<img v-show="acvieba == 3" style="width:100%;" src="../../assets/images/home/szjimg_4.png" alt="">
				<img v-show="acvieba == 4" style="width:100%;" src="../../assets/images/home/szjimg_5.png" alt=""> -->

    <!--合作品牌-->
    <!-- <div class="m2mIntro cobrand">
			<div class="introBox container">
				<h3 class="title header_title">合作品牌</h3>
				<div class="line"></div>
				<div class="cobrandBox">
					<div id="cobrand" class="carousel slide" data-ride="carousel">
						轮播图片
						<div class="carousel-inner">
							<div :class="['carousel-item',item==1?'active':'']" v-for="item in wallSize" :key="item">
								<div class="cobrandList">
									<ul>
										<li v-for="(item2,index) in brandList" :key="index"
											v-if="index<item*24 && index>=(item-1)*24">
											<img :src="item2.content_value" alt="多对多物联平台">
										</li>
									</ul>
								</div>
							</div>
						</div>
						指示符
						<ul class="carousel-indicators">
							<li data-target="#cobrand" :data-slide-to="item-1" :class="[item==1?'active':'']"
								v-for="item in wallSize" :key="item"></li>
						</ul>
						左右切换按钮
						<a class="carousel-control-prev" href="#cobrand" data-slide="prev">
							<span class="carousel-control-prev-icon"></span>
						</a>
						<a class="carousel-control-next" href="#cobrand" data-slide="next">
							<span class="carousel-control-next-icon"></span>
						</a>
					</div>
				</div>
			</div>
		</div> -->
    <!--bottomBanner-->
    <!-- <div class="btBanner container-fluid">
			<div class="container">
        
			</div>
		</div> -->

    <div>
      <img
        style="display: block; width: 100%"
        src="https://img.duoduiduo.com/gg/19/27/9668ba6bb22d46af94fa846426217af8.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "多对多物联集团、银发经济、人口老龄化、心脑血管、慢性疾病、血压高、血糖、体脂管理、中医馆、养生馆、健康管理师、科学工作站、公益行动、老年产品目录、健康机构、客户管理、拓客、医保社保、养生保健、远程管理",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商，是华为战略合作伙伴，华为健康数据与多对多实现互联互通。多对多健康管理 SaaS 系统和健康管理拓客赢利AI解决方案，为用户建立健康档案，提供健康 AI 管理。业务涵盖医院、养老机构、社区中心、康养中心、养老院、中医馆、养生馆等。针对人口老龄化现状和银发经济趋势，多对多加入了科学健康指导工作站，百城千镇家庭防大病数智服务健康公益行动办公室。开放专业健康管理师进驻，实现合作加盟共赢。",
      },
    ],
  },
  data() {
    return {
      swiperOptionTop: {
        slidesPerView: 1,
        initialSlide: 0,
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
        },
        loop: true,
        autoplay: {
          delay: 4000, //1秒切换一次
        },
        // direction: "horizontal"
      },
      swiperData: [
        {
          imgUrl: require("../../assets/images/home/home_lun1.jpg"),
        },
        //{
        //	imgUrl: require('../../assets/images/home/home_lun2.png'),
        //},
      ],
      acvieba: 0,
      jiankangdata: [
        "健康产品智能化",
        "数智系统一体化",
        "远程服务精准化",
        "健康效果可视化",
        "健康预警实时化",
      ],
      autoplay: false,
      carouselIndex: 0,
      //首页推荐新闻（3条）
      newsList: [],
      //品牌墙数据
      brandList: [],
      //品牌墙页数
      wallSize: 2,
      url: "",
    };
  },
  created() {
    this.getToken();
  },
  mounted() {},
  methods: {
    jiankangdatabtn(index) {
      this.acvieba = index;
    },
    //获取token
    getToken() {
      let token = window.localStorage.getItem("token");
      if (!token) {
        this.sendHttp({
          method: "post",
          url: `${this.accountUrl}/api/accesstoken`,
          data: {},
        }).then((res) => {
          if (res.code == "0") {
            // 把获取到的存到本地缓存
            window.localStorage.setItem("token", res.data.token);
            this.$router.push({
              path: this.url,
            });
            //获取token后开始获取页面数据
            //获取3条推荐新闻
            this.getNews();
            //获取品牌墙数据
            this.getBrand();
          }
        });
      } else {
        this.getNews();
        //获取品牌墙数据
        this.getBrand();
      }
    },
    //到新闻页
    toNews() {
      this.$router.push("/news");
    },
    //到视频列表
    toVideo() {
      this.$router.push({
        path: "/about/videoGroup",
      });
    },
    //跳转至新闻内容
    toNewsCont(id) {
      this.$router.push({
        path: "/newsContent/" + id,
        params: {
          id,
        },
      });
    },
    //获取首页推荐新闻
    getNews() {
      this.sendHttp({
        url: this.baseUrl + "/article/newslist",
        method: "post",
        data: {
          alias: "www",
          is_recommend: 1,
          limit: 3,
        },
      }).then((res) => {
        if (res.code == 0) {
          //console.log(res);
          this.newsList = res.data;
          //推荐新闻发布时间取年月日
          for (let i = 0; i < res.data.length; i++) {
            let time = res.data[i].create_time;
            let createTime = [];
            createTime = time.split(" ");
            this.newsList[i].create_time = createTime[0];
          }
        }
      });
    },
    //获取品牌墙信息
    getBrand() {
      this.sendHttp({
        url: this.baseUrl + "/index/getplate",
        method: "post",
        data: {
          alias: "brandwall",
          webpage: "www",
          limit: 90,
        },
      }).then((res) => {
        if (res.code == "0") {
          //console.log(res);
          this.brandList = res.data.image;
          // this.wallSize = Math.ceil(res.data.image.length / 24);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.bottom {
  box-shadow: none !important;
}

.header_title {
  font-size: 28px;
  color: #000;
  font-weight: bold;
}

/*多对多*/
.m2mIntro {
  // padding: 2% 0;

  .title {
    text-align: center;
  }

  .line {
    height: 2px;
    width: 50px;
    background: #ee7b1d;
    margin: 20px auto;
  }

  p {
    font-size: 14px;
    color: #8d8e90;
    margin: 0 auto;
    line-height: 30px;
    text-align: center;
    padding: 0;
    padding-bottom: 40px;
  }

  .expertList {
    ul {
      display: flex;
      justify-content: space-between;

      li {
        .imgBox {
          width: 50%;
          height: 50%;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px 0;

          img {
            width: 100%;
            margin: 30px 0 50px;
          }
        }

        &:last-child {
          .imgBox {
            width: 70%;
          }
        }

        width: 220px;

        @media (max-width: 992px) {
          width: 160px;
          padding: 30px 15px;
          padding-bottom: 60px;
        }

        @media (max-width: 768px) {
          width: 45%;
          padding: 30px 15px;
          padding-bottom: 60px;
        }

        margin: 0 auto;
        text-align: center;
        border: 1px solid #ee7b1d;
        box-shadow: #eee 1px 3px 5px;
        border-radius: 15px;
        padding: 50px 15px;
        padding-bottom: 60px;
        margin-bottom: 20px;

        p {
          width: 100%;
          padding-bottom: 0;
          color: #333333;
          line-height: 20px;
        }

        .title {
          font-size: 18px;
          font-weight: bold;
          padding: 0 0;

          @media (max-width: 768px) {
            padding: 10px 0;
          }
        }

        &:hover {
          border: 1px solid #ee7b1d;
          box-shadow: #ee7b1d 1px 1px 5px;
          background: #fdeedb;
        }
      }
    }
  }
}

/*新闻资讯*/
.news {
  background: #f5f6fa;
  padding-bottom: 5%;

  @media (max-width: 992px) {
    padding-bottom: 12%;
  }

  @media (max-width: 576px) {
    padding-bottom: 18%;
  }

  .introBox {
    margin: 0 auto;
  }

  .honour {
    margin-top: 5%;
    .tit {
      font-size: 28px;
      color: #000;
      font-weight: bold;
    }
    .honourText {
      padding: 8%;
      line-height: 34px;
      font-size: 18px;
      color: #3e3a39;
    }

    @media (max-width: 992px) {
      .honourText {
        padding: 4%;
      }

      .carousel-indicators {
        bottom: -60px;
      }

      .carousel-control-prev,
      .carousel-control-next {
        display: none;
      }
    }

    @media (max-width: 768px) {
      .carousel-indicators {
        bottom: -10%;
      }
    }

    @media (max-width: 576px) {
      .carousel-indicators {
        bottom: -8%;
      }
    }

    .carousel-indicators {
      margin: 0;

      li {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 0;
        background: #ee8835;
      }
    }

    .tit {
      text-align: center;
    }

    .honourBox {
      #honour {
      }

      box-sizing: border-box;
      margin: 0 auto;
      // background: url("~img/home/honourBg.png") no-repeat center;
      background-size: contain;

      @media (max-width: 992px) {
        background: #fff;
        border: 2px solid #eee;
        border-radius: 15px;
        box-shadow: 2px 2px 5px #eee;
      }
    }
  }

  .newsBox {
    display: flex;
    justify-content: space-between;
    padding-top: 40px;

    .left {
      margin: 0 auto;

      video {
        border: 1px solid #ddd;
        border-image: -webkit-linear-gradient(#6275b3, #62e6cf) 20 20;
        border-image: -moz-linear-gradient(#6275b3, #62e6cf) 20 20;
        border-image: -o-linear-gradient(#6275b3, #62e6cf) 20 20;
        border-image: linear-gradient(#6275b3, #62e6cf) 20 20;
        width: 100%;
        object-fit: fill;
      }
    }

    .more {
      margin: 20px 0;
      padding: 8px 0;
      border: 1px solid #ee8835;
      width: 150px;
      text-align: center;
      border-radius: 15px;
      cursor: pointer;
    }

    .right {
      margin: 0 auto;
      position: relative;

      @media (max-width: 576px) {
        padding-bottom: 60px;
      }

      .newsList {
        height: 56%;

        .item {
          border-radius: 10px;
          margin: 0;
          height: 45%;
          display: flex;
          justify-content: right;
          background: #fff;
          box-shadow: #eee 2px 2px 5px;
          font-size: 8px;
          line-height: 17px;
          margin-bottom: 10px;
          box-shadow: #eee 2px 2px 4px;
          cursor: default;
          overflow: hidden;

          @media (max-width: 992px) {
            height: 110px;
            overflow: hidden;
          }

          .tit {
            display: flex;
            align-items: center;
            line-height: 30px;
            padding: 0 10px;
            font-weight: bold;
          }

          .line {
            background: #b5b5b5;
            width: 50px;
            margin: 5px 0;
            margin-left: 228px;
            height: 1px;
          }

          .newsImg {
            height: 100%;
            padding: 0;
            background: #eee;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .newsCont {
            text-align: right;
            padding: 10px 5px;
            color: #9fa0a0;
            width: 100%;
            overflow: hidden;
            line-height: 22px;
            background: #fff;

            .newstit {
              font-size: 15px;
              font-weight: bold;
            }

            .newsTime {
              padding-top: 14px;
            }
          }

          &:hover {
            .tit {
              color: #ee8835;
            }

            .newsCont {
              .newstit {
                color: #ee8835;
              }
            }
          }
        }
      }

      .moreNews {
        display: flex;
        align-items: center;
        justify-content: left;
        font-size: 14px;
        position: absolute;
        bottom: 20px;

        .line {
          width: 40px;
          height: 1px;
          margin: 0;
          background: #ee7b1d;
        }

        .text {
          cursor: pointer;
          padding-left: 5px;
        }
      }
    }
  }
}

// 企业荣誉
.enterprise_honor {
  position: relative;

  .head_title {
    text-align: center;
    margin-bottom: 30px;

    .title {
      font-size: 28px;
      color: #000;
      font-weight: bold;
    }

    .line {
      width: 40px;
      height: 2px;
      margin: 20px auto 0;
      background: #ee7b1d;
    }
  }

  .beckg_1 {
    height: 210px;
    width: 100%;
    background-color: #f5f6fa;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .beckg_2 {
    height: 120px;
    width: 100%;
    background-color: #fff;
    position: absolute;
    top: 210px;
    left: 0;
    z-index: -1;
  }

  .enterprise_honor_content {
    position: relative;
    width: 1000px;
    height: 240px;
    margin: 0 auto;
    background-image: url(../../assets/images/home/enterprisehonor1.png);
    background-size: 100% 100%;
    box-shadow: 0px 0px 10px 3px #eeeeff;

    @media (max-width: 576px) {
      width: 100%;
      height: 350px;
      background-color: #fff;
      background-image: none !important;
    }

    .left {
      width: 64px;
      height: 69px;
      background-image: url(../../assets/images/home/enterprisehonor2.png);
      background-size: 100% 100%;
      position: absolute;
      top: 86px;
      left: -30px;
      z-index: 3;

      @media (max-width: 576px) {
        display: none;
      }
    }

    .content {
      padding: 48px 100px 0;

      @media (max-width: 576px) {
        padding: 20px 10px;
      }

      p {
        font-size: 16px;
        color: #333;
        line-height: 32px;

        @media (max-width: 576px) {
          font-size: 14px;
        }
      }
    }

    .right {
      width: 64px;
      height: 69px;
      background-image: url(../../assets/images/home/enterprisehonor3.png);
      background-size: 100% 100%;
      position: absolute;
      top: 86px;
      right: -30px;
      z-index: 3;

      @media (max-width: 576px) {
        display: none;
      }
    }
  }
}

/*合作品牌*/
.cobrand {
  @media (max-width: 992px) {
    padding-bottom: 10%;
  }

  #cobrand {
    .carousel-indicators {
      bottom: -8%;

      @media (max-width: 768px) {
        bottom: -3%;
      }

      li {
        background: #ee8835;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 0;
      }
    }

    .carousel-control-prev-icon {
      background: url("~img/home/prev.png") no-repeat center;
      background-size: cover;
    }

    .carousel-control-prev {
      left: -14%;
    }

    .carousel-control-next {
      right: -14%;
    }

    @media (max-width: 1200px) {
      .carousel-control-prev {
        left: -16%;
      }

      .carousel-control-next {
        right: -16%;
      }
    }

    .carousel-control-next-icon {
      background: url("~img/home/next.png") no-repeat center;
      background-size: cover;
    }

    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      display: inline-block;
      width: 50px;
      height: 66px;
    }

    @media (max-width: 576px) {
      .carousel-control-prev-icon,
      .carousel-control-next-icon {
        display: none;
      }
    }
  }

  .introBox {
    @media (max-width: 1300px) {
      max-width: 86%;
    }

    @media (max-width: 1200px) {
      max-width: 66%;
    }

    @media (max-width: 576px) {
      max-width: 80%;
    }
  }

  .cobrandBox {
    // padding-top: 40px;
    position: relative;

    .prev {
      width: 80px;
      height: 80px;
      background: url("~img/home/prev.png") no-repeat;
      background-size: 100%;
      position: absolute;
      top: 118px;
      left: -140px;
      z-index: 1000;
    }

    .next {
      width: 80px;
      height: 80px;
      background: url("~img/home/next.png") no-repeat;
      background-size: 100%;
      position: absolute;
      top: 118px;
      right: -140px;
      z-index: 1000;
    }

    .cobrandList {
      ul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        li {
          width: 100%;
          // border: 1px solid #333333;
          margin-bottom: 20px;

          @media (max-width: 768px) {
            width: 100%;
          }

          img {
            width: 100%;
            height: 100%;
          }

          &.null {
            width: 180px;
            height: 0;
            visibility: hidden;
          }
        }
      }
    }

    .Comore {
      text-align: center;
      border-radius: 15px;
      border: 1px solid #ee8835;
      width: 160px;
      margin: 20px auto;
      padding: 8px 0;
      letter-spacing: 4px;
      cursor: pointer;
    }
  }
}

/*btBanner*/
.btBanner {
  padding: 6% 0 4% !important;
  // background: url("https://img.duoduiduo.com/goods/3/12/e547eb7f25834f18a3f0ede64418598e.png") no-repeat;
  background-size: cover;
  width: 100%;
  // height: 332px;
  text-align: center;
  overflow: hidden;

  h1 {
    color: #fff;
    font-size: 2rem !important;
  }

  .m2m {
    color: #fff;
    width: 210px;
    text-align: center;
    padding: 5px 30px;
    margin: 0 auto;
    margin-top: 2%;
    letter-spacing: 2px;
    border: 1px solid #ffffff;
    border-bottom: 2px solid #ffffff;
  }

  @media (max-width: 992px) {
    h1 {
      font-size: 1.4rem !important;
    }

    .m2m {
      margin: 20px auto;
    }
  }

  @media (max-width: 768px) {
    .container {
      max-width: 680px;

      h1 {
        font-size: 1.1rem !important;
      }

      .m2m {
        margin: 10px auto;
        font-size: 0.9rem;
      }
    }
  }

  @media (max-width: 576px) {
    height: 150px;

    .container {
      max-width: 130%;

      h1 {
        font-size: 1rem !important;
        line-height: 1.4rem !important;
      }

      .m2m {
        // width: 120px;
        margin: 10px auto;
        font-size: 0.5rem;
      }
    }
  }
}

.honour_flex {
  display: flex;
  flex-wrap: wrap;
  @media (max-width: 576px) {
    padding-top: 30px;
  }

  li {
    flex: 1;
    flex-basis: 13%;
    margin: 0 10px 20px;

    @media (max-width: 768px) {
      width: 160px;
      flex-basis: 43%;
    }

    img {
      width: 100%;
      height: 100px;
    }
  }
}
.baner_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
}
.xxxxxx {
  font-weight: 600;
  font-size: 16px;
  padding-bottom: 8px;
  cursor: pointer;
}
.xxxxxx-active {
  color: #ee7b1d;
  border-bottom: 2px solid #ee7b1d;
}
</style>
<style>
.swiper-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
}
.swiper-pagination .swiper-pagination-bullet-active {
  background-color: #ee7b1d;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue